import { render } from "./RadioMenuDialog.vue?vue&type=template&id=5d32f9b7&scoped=true&ts=true"
import script from "./RadioMenuDialog.vue?vue&type=script&lang=ts"
export * from "./RadioMenuDialog.vue?vue&type=script&lang=ts"

import "./RadioMenuDialog.vue?vue&type=style&index=0&id=5d32f9b7&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d32f9b7"]])

export default __exports__